// extracted by mini-css-extract-plugin
module.exports = {"canvas":"shareCard_canvas__J_DTp","canvas_wrapper":"shareCard_canvas_wrapper__1vlYU","canvas_download_icon":"shareCard_canvas_download_icon__2VaVn"};